import { useState, useRef, useEffect } from 'react';
import handleInputChange from '../function/HandleInputsChange';
import DropdownPortal from '../inputs/DropdownPortal';
import '../css/Configuration.css';

function Configuration({
  option,
  setOptions,
  inputs,
  setInputs,
  disabled,
  value,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [coords, setCoords] = useState(null);
  const dropdownRef = useRef(null);

  const optionChoice = option.options;

  const handleOptionSelection = (selectedValue) => {
    handleInputChange(
      option.field,
      selectedValue,
      inputs,
      setInputs,
      setOptions
    );
    setIsOpen(false);
  };

  const openDropdown = () => {
    if (!dropdownRef.current) return;

    const rect = dropdownRef.current.getBoundingClientRect();
    setCoords({
      top: rect.bottom + window.scrollY,
      left: rect.left + window.scrollX,
      width: rect.width,
    });

    setIsOpen(true);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside, {
      passive: true,
    });
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="custom-dropdown" ref={dropdownRef}>
      {disabled ? (
        <div className="result-text">{value}</div>
      ) : (
        <>
          <div
            className="selected-option"
            onPointerDown={(e) => {
              if (!isOpen) {
                e.preventDefault();
                openDropdown();
              }
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {value ? (
              <img
                src={`${process.env.PUBLIC_URL}/pics/configuration/config${value}.png`}
                alt={`Configuration ${value}`}
                className="option-image"
              />
            ) : (
              <span>select an option</span>
            )}
          </div>
          {isOpen && (
            <DropdownPortal>
              <div
                className="dropdown-options"
                onPointerDown={(e) => e.stopPropagation()}
                style={{
                  position: 'absolute',
                  top: coords.top,
                  left: coords.left,
                  width: coords.width,
                  zIndex: 999999,
                }}
              >
                {optionChoice.map((optionValue, index) => (
                  <div
                    key={index}
                    className={`dropdown-option ${value === optionValue ? 'active' : ''}`}
                    role="option"
                    onPointerDown={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      handleOptionSelection(optionValue);
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                  >
                    <img
                      src={`${process.env.PUBLIC_URL}/pics/configuration/config${optionValue}.png`}
                      alt={`Configuration ${optionValue}`}
                      className="option-image"
                    />
                  </div>
                ))}
              </div>
            </DropdownPortal>
          )}
        </>
      )}
    </div>
  );
}

export default Configuration;
